import { useEffect, useState } from "react";
import { MapPin } from "lucide-react";
import { CtaButton } from "@/components/site/CtaButton";
import { SectionHeading } from "@/components/site/Sections";
import { getInspectionOptions } from "@/lib/api";
import { MAP_EMBED, SPECIALIZED } from "@/data/fieldServices";

export const ServiceAreaMap = () => {
  const [areas, setAreas] = useState([]);
  useEffect(() => {
    getInspectionOptions().then((o) => setAreas(o.service_areas)).catch(() => setAreas([]));
  }, []);
  return (
    <section id="service-area" className="py-20 lg:py-24" data-testid="fs-service-area">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 lg:grid-cols-2 lg:px-8">
        <div>
          <SectionHeading eyebrow="Service Area" title="A Pennsylvania-based real estate field services provider." subtitle="Current coverage is listed below. Availability depends on location and assignment; we confirm every request before scheduling." />
          <div className="mt-8 flex flex-wrap gap-2" data-testid="fs-area-list">
            {areas.map((a) => (
              <span key={a} className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-4 py-2 text-sm text-[#0B132B]"><MapPin className="h-4 w-4 text-gold" /> {a}</span>
            ))}
          </div>
          <h3 className="mt-10 font-display text-2xl font-bold text-[#0B132B]">Need an Inspection in Pennsylvania? Request a Quote Today.</h3>
          <CtaButton to="/request-inspection" className="mt-5" data-testid="fs-area-quote-btn">Request a Quote</CtaButton>
        </div>
        <iframe title="Vertexhub service area map" src={MAP_EMBED} loading="lazy" className="h-[420px] w-full rounded-3xl border border-slate-200" data-testid="fs-map" />
      </div>
    </section>
  );
};

export const SpecializedSection = () => (
  <section className="border-y border-slate-200 bg-white py-16" data-testid="fs-specialized">
    <div className="mx-auto max-w-7xl px-4 lg:px-8">
      <SectionHeading eyebrow="Through qualified professionals" title="Specialized Services Through Qualified Professionals" />
      <div className="mt-8 flex flex-wrap gap-2">
        {SPECIALIZED.map((s) => <span key={s} className="rounded-full bg-[#F5F3EC] px-4 py-2 text-sm text-[#0B132B]">{s}</span>)}
      </div>
      <p className="mt-5 max-w-3xl text-sm text-slate-500">
        These services are coordinated through appropriately licensed or registered third-party professionals and are subject to professional licensing, registration, insurance and availability. Vertexhub Ventures does not hold trade licenses for these services. Mention them under "Additional services needed" in your request.
      </p>
    </div>
  </section>
);
